import { EnumModel } from '../../models/neum.model';

export enum RoleEnum {
  Admin = 0,
  Tramitador = 1,
  ChatAdmin = 2,
}

export const roles: Array<EnumModel> = [
  {
    value: RoleEnum.Admin,
    name: RoleEnum[RoleEnum.Admin],
    description: 'Administrador',
  },
  {
    value: RoleEnum.Tramitador,
    name: RoleEnum[RoleEnum.Tramitador],
    description: 'Tramitador',
  },
  {
    value: RoleEnum.ChatAdmin,
    name: RoleEnum[RoleEnum.ChatAdmin],
    description: 'Administrador del chat',
  },
].sort((a, b) => a.description.localeCompare(b.description));
